import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserController } from '@domain';

/**
 * Libera a rota apenas para administradores internos (staff) do RapiDocs
 * (`user.profile === USER_ADMIN_RAPIDOCS`). É um perfil GLOBAL, distinto do
 * `AdminGuard`, que valida o papel dentro de uma empresa (`companyAccess.role`).
 */
@Injectable({
    providedIn: 'root',
})
export class RapidocsAdminGuard implements CanActivate {
    private _router = inject(Router);
    private _userController = inject(UserController);

    public canActivate(): boolean {
        // Garante a hidratação do usuário (signal ou cookie) antes de checar o
        // perfil — cobre o cenário de reload direto na rota, quando o signal
        // ainda não foi populado. O `profile` é persistido no cookie.
        this._userController.getCurrentUser();

        if (!this._userController.isRapidocsAdmin()) {
            this._router.navigate(['/platform']);
            return false;
        }

        return true;
    }
}
